<script setup lang="ts">
withDefaults(defineProps<{src:string;alt:string;priority?:boolean;width?:number;height?:number}>(),{priority:false})
</script>
<template>
 <img class="content-photo" :src="src" :alt="alt" :width="width" :height="height" :loading="priority?'eager':'lazy'" :fetchpriority="priority?'high':'auto'" />
</template>
